import React from 'react';
import { inject, observer } from 'mobx-react';
import H5CommonPopup from './h5';
import PCCommonPopup from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';

interface CommonPopupProps {
    app?: AppStore;
    variant?: 'pc' | 'h5';
    desktopMode?: boolean;
    site?: SiteStore;
    user?: UserAction;
    // 是否显示标题，默认显示
    isShowTitle?: boolean;
    // 是否显示取消按钮
    isShowCancel?: boolean;
    // 是否显示确定按钮
    isShowConfirm?: boolean;
    // 是否显示
    visible: boolean;
        // 显示隐藏
    onHidePopup?: Function
    // 标题
    title?: string;
    // 使用richtext解析
    useRichtext?: boolean
    // richtext内容
    richtextContent?: any
    // 取消事件
    onCancelChange?: Function
    // 确定事件
    onConfirmButtonChange?: Function
    // 取消按钮文字
    cancelText?: string
    // 确定按钮文字
    confirmText?: string
    // 确定按钮不可点击状态
    confirmDisabled?: boolean
    // 是否给弹窗内容添加背景样式 class
    popupContentBg?: boolean;
    // childrenSlot 容器的行内样式
    childrenSlotStyle?: React.CSSProperties;
    // 插槽相关属性
    children?: React.ReactNode; // 内容插槽
}

@inject('app', 'site', 'user')
@observer
class CommonPopup extends React.Component<CommonPopupProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
        // console.log('组件组件');
    }

    render() {
        const { site, app, variant, desktopMode, ...props } = this.props;
        const platform = variant || app?.platform || 'h5';
        if (platform === 'pc') {
            return <PCCommonPopup {...props} />;
        } else {
            return <H5CommonPopup {...props} desktopMode={desktopMode} />;
        }
        
        
    }
}

export default CommonPopup;
